<template>
	<div id="hrms75e-detail-tab2" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab2">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRMS75EC3']['10'] }}
      </h3>
    </div>
    <div id="tab2" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive panel-detail-filter">
          <div class="col-md-6">
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRMS75EC3']['20'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detail.detail.desc_codempid }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRMS75EC3']['30'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detail.detail.desc_codcomp }}</div>
                </div>
              </div>
            </form>
          </div>
          <div class="col-md-6">
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRMS75EC3']['40'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detail.detail.desc_codpos }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRMS75EC3']['50'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detail.detail.desc_codjob }}</div>
                </div>
              </div>
            </form>
          </div>
        		<hrms-table  :columns="detailTab2Columns" 
                         :data="detail.table"
                         :selectRowBool="false"
                         :selectBtnDisp="true"
                         :selectEvent="selectEvent"
                         :confirmSelectBtnDisp="false"
                         ref="detailTab2Table" />
        </div>
        <div class="col-md-12 ">
          <button type="button" class="btn bg-color-skin pull-right" @click="togglePopupDetailTab2()">{{ labels['HRMS75EC3']['130'] }}</button>  
          <button type="button" hidden ref="detailTab2TableBtn" data-toggle="modal" data-target="#hrms75e-popup-tab2"></button>  
        </div>
      </div>
    </div>
      <popup  :labels="labels"
              :nowLang="nowLang"
              :labelsButton="labelsButton"
              :detailTab2Popup="detailTab2Popup"
              :detailTab2PopupColumns="detailTab2PopupColumns"
              :setAddCodcours="setAddCodcours" />
  </div>

</template>

<script>
import popup from 'components/hrms75e/popupTab2'
import swal from 'sweetalert'

export default {
  name: 'hrms75e-detail-tab2',
  props: [
    'labels',
    'labelsButton',
    'nowLang',
    'detail',
    'detailTab2Columns',
    'detailTab2Popup',
    'detailTab2PopupColumns',
    'receivedHrms75eDetailTab2Popup',
    'setAddCodcours'
  ],
  methods: {
    togglePopupDetailTab2 () {
      this.$refs.detailTab2Table.$emit('$selectEventBuiltIn')
    },
    selectEvent (checkedDataRows) {
      if (checkedDataRows.length > 0) {
        let codskillConcat = checkedDataRows.map(function (dataRow) {
          return dataRow.codskill
        }).reduce(function (sum, val) {
          return sum + ',' + val
        })
        this.receivedHrms75eDetailTab2Popup(codskillConcat)
        this.$refs.detailTab2TableBtn.click()
      } else {
        swal({
          title: 'ยืนยันการทำรายการ',
          text: 'รายการยังไม่ถูกเลือก'
        })
      }
    }
  },
  components: {
    popup
  }
}
</script>


// WEBPACK FOOTER //
// detailTab2.vue?20c67b09